import { useSelector } from 'react-redux';

import { ThemeProvider } from '@mui/material/styles';
import { Box, CssBaseline, StyledEngineProvider } from '@mui/material';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import React from 'react';
import { useLocation } from 'react-router';
import { useState } from 'react';
import { useEffect } from 'react';
import { getAccessByToken } from 'API/Access/apis';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
// import { DownloadConfigFile } from 'API/Config/api';

// ==============================|| APP ||============================== //

const App = () => {
  const customization = useSelector((state) => state.customization);
  const app_version = '0.0.0';
  console.log("app_version", app_version);
  const [UserAccess, setUserAccess] = useState(null)
  const [Error, setError] = useState(false)
  const [ErrorMessage, setErrorMessage] = useState("Unauthorized user")
  const[PreventPage,setPreventPage]=useState(false)
  const route =useLocation().pathname

  // console.log(window.history);
  const token = sessionStorage.getItem("token");

// console.log=function(){}

  useEffect(() => {
    if (token && route!=="/change-password") {
      setPreventPage(true)
      getAccessByToken(setUserAccess, setError)
      // DownloadConfigFile()
    }
  }, [token])

  const Access = [
    {
      id: 'A',
      name: 'menu_items',
      display_name: 'Menu Items',
      children: [
        {
          id: 1,
          name: 'product_master',
          display_name: 'Product Master',
          route: "/Admin/AddProduct"
        },
        {
          id: 2,
          name: 'field_master',
          display_name: 'Field Master',
          route: "/Admin/AddDP"
        },
        {
          id: 3,
          name: 'category_setup',
          display_name: 'Category Setup',
          route: "/Admin/Categorysetup"
        },

        {
          id: 4,
          name: 'access_management',
          display_name: 'Access Management',
          route: "/Admin/AccessManagement"
        },
        {
          id: 5,
          name: 'manage_group',
          display_name: 'Manage Group',
          route: "/Admin/CreateGroup"
        },
        {
          id: 6,
          name: 'view_group',
          display_name: 'View Group',
          route: "/Admin/ViewAllAccess"
        },
        {
          id: 7,
          name: 'view_mdm',
          display_name: 'View MDM',
          route: "/Admin/ViewDatapoints"
        },
        {
          id: 8,
          name: 'view_products',
          display_name: 'View Products',
          route: "/Admin/ViewProducts"
        }
      ]
    },

    {
      id: 'B',
      name: 'onboarding',
      display_name: 'Onboarding',
      children: [
        {
          id: 9,
          name: 'agent_onboarding',
          display_name: 'Agent Onboarding',
          route: '/Admin/agentonboarding'
        },
        {
          id: 37,
          name: 'deboarding_request',
          display_name: 'Deboarding Onboarding',
          route: '/Admin/deboarding'
        },
        {
          id: 10,
          name: 'ds_onboarding',
          display_name: 'DS Onboarding',
          route: '/Admin/dsonboarding'
        },
        {
          id: 110,
          name: 'fos_onboarding',
          display_name: 'FOS Onboarding',
          route: '/Admin/fosonboarding'
        },
        {
          id: 116,
          name: 'fos_request',
          display_name: 'FOS Request',
          route: '/Admin/fosrequest'
        },
        {
          id: 11,
          name: 'request',
          display_name: 'Agent Request',
          route: "/Admin/Requests"
        },
        {
          id: 12,
          name: 'ds_request',
          display_name: 'DS Request',
          route: "/Admin/ops/DsApproval"
        },
        {
          id: 22,
          name: 'paymnet_status',
          display_name: 'Payment Status',
          route: "/Admin/payment_status"
        },
        {
          id: 23,
          name: 'paymnet_request',
          display_name: 'Payment Request',
          route: "/Admin/payment_request"
        },
        {
          id: 26,
          name: 'video_kyc',
          display_name: 'Video KYC',
          route: "/Admin/VideoKyc"
        },
        {
          id: 27,
          name: 'kyc_upload',
          display_name: 'KYC Upload',
          route: "/Admin/kycupload"
        },
        // {
        //   id: 28,
        //   name: 'wallet',
        //   display_name: 'Wallet',
        //   route: "/Admin/wallet"
        // },
        // {
        //   id: 29,
        //   name: 'ds_topup_request',
        //   display_name: 'DS Topup Request',
        //   route: "/Admin/ds_wallet_topup_request"
        // },
        // {
        //   id: 33,
        //   name: 'csp_mapping',
        //   display_name: 'CSP Mapping Request',
        //   route: "/Admin/csp_mapping_request"
        // },
        {
          id: 24,
          name: 'code_activation',
          display_name: 'Code Activation',
          route: "/Admin/Csp_Code_Activation"
        },
        {
          id: 25,
          name: 'terminal_mapping',
          display_name: 'Terminal Mapping',
          route: "/Admin/Terminal_mapping"
        },
        // {
        //   id: 35,
        //   name: 'hardware_request',
        //   display_name: 'Hardware Request',
        //   route: "/Admin/hardware_request"
        // },
        // {
        //   id: 36,
        //   name: 'bankdeposit_request',
        //   display_name: 'Bank Deposit Request',
        //   route: "/Admin/bankdeposit_request"
        // },

        {
          id: 85,
          name: 'deboarding_list',
          display_name: 'Deboarding List',
          route: "/Admin/deboarding_list"
        },
        {
          id: 101,
          name: 'ds_payment_link',
          display_name: 'Ds Paymnet Link',
          route: "/Admin/ds_payment_link"
        },
        {
          id: 106,
          name: 'aec_list',
          display_name: 'AEC List',
          route: "/Admin/aec_list"
        }
      ]
    },

    {
      id: 'C',
      name: 'mapping',
      display_name: 'Mapping',
      children: [
        {
          id:37,
          name:"rm_mapping",
          display_name: 'Location Mapping',
          route:"/Admin/rm_mapping"
        },
        {
          id: 13,
          name: 'agent_ds',
          display_name: 'Agent - DS',
          route:"/Admin/mapping"
        },
        {
          id: 14,
          name: 'ds_tm',
          display_name: 'DS - TM',
          route:"/Admin/ops/mapping/ds_tm"
        },
        {
          id: 15,
          name: 'ds_mds',
          display_name: 'DS - MDS',
          route:"/Admin/ops/mapping/ds_mds"
        },
        {
          id: 16,
          name: 'tm_mds',
          display_name: 'TM - MDS',
          route:"/Admin/ops/mapping/tm_mds"
        },
        {
          id: 17,
          name: 'tm_sh',
          display_name: 'TM - SH',
          route:"/Admin/ops/mapping/tm_sh"
        },
        {
          id: 55,
          name: 'location_mapping',
          display_name: 'Location Mapping',
          route:"/Admin/location_mapping"
        },
        {
          id: 117,
          name: 'fos_mapping',
          display_name: 'FOS Mapping',
          route:"/Admin/fos_mapping"
        }

      ]
    },

    {
      id: 'D',
      name: 'procurement',
      display_name: 'Procurement',
      children: [
        {
          id: 18,
          name: 'add_device',
          display_name: 'Add Device'
        },
        {
          id: 92,
          name: 'Device_Request',
          display_name: 'Device Request'
        },
        {
          id: 19,
          name: 'add_vendor',
          display_name: 'Add Vendor'
        },
        {
          id: 89,
          name: 'vendor_list',
          display_name: 'Vendor List',
          route: '/Admin/vendor_list',
        },
        {
          id:90,
          name:'vendor_onboarding_request',
          display_name: 'Vendor Onboarding Request',
          route: '/Admin/vendor_onboarding_request'
        },
        {
          id:91,
          name:'purchase_request',
          display_name: 'Purchase request',
          route: '/procurement/purchase_request'
        },
        {
          id:93,
          name:'product_ship',
          display_name: 'Product Shipment',
          route: '/procurement/Product_Ship'
        },
        {
          id:97,
          name:'delivery_note_status',
          display_name: 'Delivery Note Status',
          route: '/procurement/Delivery_Note_Status'
        },
        {
          id:94,
          name:'purchase_order',
          display_name: 'Purchase Order',
          route: '/Admin/purchase_order'
        },
        {
          id:95,
          name:'procurement_Head_PO_pending_Page',
          display_name: 'Procurement Head PO Pending Page',
          route: '/Admin/procurement_Head_PO_pending_Page'
        },
        {
          id:97,
          name:'payment_order',
          display_name: 'Payment Order',
          route: '/Admin/payment_orders'
        },
        {
          id:96,
          name:'invoice',
          display_name: 'Invoice',
          route: '/Admin/Invoice'
        },
        {
          id:98,
          name:'complete_payment',
          display_name: 'Complete Payment',
          route: '/Admin/complete_payment'
        },
        {
          id:100,
          name:'create_payment_order',
          display_name: 'Create Payment Order',
          route: '/procurement/create_payment_order'
        },
        {
          id:108,
          name:'branding_request',
          display_name: 'Agent Branding request',
          route: '/procurement/brandingrequest'
        },
        {
          id:109,
          name:'upload_brand',
          display_name: 'Upload Branding',
          route: '/procurement/uploadbrand'
        },
        {
          id:110,
          name:'brand_dashboard',
          display_name:'Branding dashboard',
          route:'/branding/dashboard'
        },
         {
          id:120,
          name:'stock_dashboard',
          display_name:'Stock dashboard',
          route:'/stock/dashboard'
        }
      ]
    },

    {
      id: 'E',
      name: 'limit_management',
      display_name: 'Limit Management',
      children: [
        {
          id: 20,
          name: 'request',
          display_name: 'Request'
        },
        {
          id: 21,
          name: 'sbi_kiosk',
          display_name: 'SBI Kiosk'
        },
        {
          id: 84,
          name: 'limit_topup_checker',
          display_name: 'Topup Checker',
          route: '/Admin/limit/topup_checker',
        },
      ]
    },
    {
      id: 'F',
      name: 'services',
      display_name: 'Services',
      children: [
        {
          id: 30,
          name: 'partner_agreement',
          display_name: 'Partner Agreement',
          route: '/Admin/Partner_Agreement',
        },
        {
          id: 31,
          name: 'payment_report',
          display_name: 'Payment Report',
          route: '/Admin/Payment_report',
        },
        {
          id: 34,
          name: 'Csp_report',
          display_name: 'CSP Report',
          route: '/Admin/Csp_report',
        },
        {
          id: 32,
          name: 'service_status',
          display_name: 'Onboarding Status',
          route: '/Admin/Service_status',
        },
        {
          id: 101,
          name: 'agreement',
          display_name: 'Agreement',
          route: '/Admin/agreement',
        },
        {
          id: 102,
          name: 'userlist',
          display_name: 'User List',
          route: '/Admin/agreement',
        },
        {
          id: 103,
          name: 'dslist',
          display_name: 'DS List',
          route: '/Admin/Dsuserlist',
        },
        {
          id: 107,
          name: 'csp_status',
          display_name: 'CSP Status',
          route: '/Admin/csp_status',
        },
        {
          id: 118,
          name: 'fos_list',
          display_name: 'FOS List',
          route:"/Admin/fos_list"
        }

      ]
    },
    {
      id: 'G',
      name: 'recon',
      display_name: 'Recon',
      children: [
        {
          id: 38,
          name: 'Recon_Fi',
          display_name: 'FI',
          route: '/Admin/Recon_Fi',
        },
        {
          id: 39,
          name: 'Recon_NonFi',
          display_name: 'Non FI',
          route: '/Admin/Recon_NonFi',
        },
        {
          id: 43,
          name: 'FI Recon Report for Admin',
          display_name: 'FI Recon Report for Admin',
          route: '/Admin/Fi_Recon_Report',

        },
        {
          id: 44,
          name: 'Non FI Recon Report for Admin',
          display_name: 'Non FI Recon Report for Admin',
          route: '/Admin/NonFi_Recon_Report',

        },
      ]
    },
    {
      id: 'H',
      name: 'hardware_allocation',
      display_name: 'Hardware Allocation',
      children: [
        {
          id: 40,
          name: 'MATM_Activation_Report',
          display_name: 'MATM Activation Report',
          route: '/Admin/MATM_Activation_Report',
        },
        {
          id: 41,
          name: 'Passbook_printer_Activation_Report',
          display_name: 'Passbook printer Activation Report',
          route: '/Admin/Passbook_printer_Activation_Report',
        },
        {
          id: 42,
          name: 'Tab_Activation_Report',
          display_name: 'Tab Activation Report',
          route: '/Admin/Tab_Activation_Report',
        },
      ]
    },
    {
      id: 'I',
      name: 'analytics',
      display_name: 'Analytics',
      children: [
        {
          id: 53,
          display_name: 'Dashboard',
          name:"analytics_dashboard",
          route: '/Department/Analytics',
        }
      ]
    },
    {
      id: 'J',
      name: 'Audit_Complaince',
      display_name: 'Audit and Compliance',
      children: [
        {
          id: 54,
          display_name: 'Transaction',
          name:"Audit_Complaince_transaction",
          route: '/Department/audit/transaction',
        },
        {
          id: 57,
          display_name: 'Activity',
          name:"Audit_Complaince_activity",
          route: '/Department/audit/activity',
        }
      ]
    },
    {
      id: 'K',
      name: 'Corporate',
      display_name: 'Corporate',
      children: [
        {
          id: 45,
          display_name: 'Dashboard',
          name:"corporate_dashboard",
          route: '/Department/Corporate',
        }
      ]
    },
    {
      id: 'L',
      name: 'Finance_Account',
      display_name: 'Finance and Account',
      children: [
        {
          id: 46,
          display_name: 'Ratna',
          name:"Finance_Account_ratna",
          route: '/Department/finance/ratna',
        },
        {
          id: 58,
          display_name: 'Hardware',
          name:"Finance_Account_HARDWARE",
          route: '/Department/finance/hardware',
        }
      ]
    },
    {
      id: 'M',
      name: 'Hr_Admin',
      display_name: 'Hr and Admin',
      children: [
        {
          id: 47,
          display_name: 'Code Activation',
          name:"Hr_Admin_dashboard",
          route: '/Department/Hr_admin/code_activation',
        }
      ]
    },
    {
      id: 'N',
      name: 'it',
      display_name: 'IT',
      children: [
        {
          id: 48,
          display_name: 'Dashboard',
          name:"it_dashboard",
          route: '/Department/IT',
        }
      ]
    },
    {
      id: 'O',
      name: 'marketing',
      display_name: 'Marketing',
      children: [
        {
          id: 49,
          display_name: 'Ratna',
          name:"marketing_dashboard_ratna",
          route: '/Department/Marketing/ratna',
        },
        {
          id: 59,
          display_name: 'Code Activation',
          name:"marketing_dashboard_code_activation",
          route: '/Department/Marketing/code_activation',
        },
        {
          id: 60,
          display_name: 'Mandate',
          name:"marketing_dashboard_mandate",
          route: '/Department/Marketing/mandate',
        },
        {
          id: 61,
          display_name: 'Network',
          name:"marketing_dashboard_network",
          route: '/Department/Marketing/Network',
        }
      ]
    },
    {
      id: 'P',
      name: 'operations',
      display_name: 'Operations',
      children: [
        {
          id: 50,
          display_name: 'Transaction',
          name:"operations_dashboard_transaction",
          route: '/Department/Operation/transactions',
        },
        {
          id: 63,
          display_name: 'Code Activation',
          name:"operations_dashboard_code_activation",
          route: '/Department/Operation/code_activation',
        },
        {
          id: 64,
          display_name: 'Mandate',
          name:"operations_dashboard_mandate",
          route: '/Department/Operation/mandate',
        }
      ]
    },
    {
      id: 'Q',
      name: 'Revenue_Assurance',
      display_name: 'Revenue and Assurance',
      children: [
        {
          id: 51,
          display_name: 'Dashboard',
          name:"Revenue_Assurance_dashboard",
          route: '/Department/Renvenue_assurance',
        }
      ]
    },
    {
      id: 'R',
      name: 'sales',
      display_name: 'Sales',
      children: [
        {
          id: 52,
          display_name: 'Code Activation',
          name:"code_activation",
          route: '/Department/Sales/code_activation',
        },
        {
          id: 66,
          display_name: 'CSP Network',
          name:"csp_network",
          route: '/Department/Sales/csp_network',
        },
        {
          id: 67,
          display_name: 'Mandate',
          name:"mandate",
          route: '/Department/Sales/mandate',
        },
        {
          id: 69,
          display_name: 'CSP Activity',
          name:"csp_activity",
          route: '/Department/Sales/csp_activity',
        },
        {
          id: 70,
          display_name: 'Transaction Report',
          name:"transaction_report",
          route: '/Department/Sales/transaction_report',
        },
      ]
    },
    {
      id: 'S',
      name: 'commission_ratna',
      display_name: 'Commission Ratna',
      children: [
        {
          id: 56,
          display_name: 'Transactional Report',
          name:"transaction_reports",
          route: '/Department/transaction_reports',
        }
      ]
    },

    {
      id: 'T',
      name: 'dashboards',
      display_name: 'Dashboards',
      children: [
        {
          id: 75,
          display_name: 'Code Activation',
          name:"code_activation",
          route: '/Department/code_activation',
        },
        {
          id: 76,
          display_name: 'CSP Network',
          name:"csp_network",
          route: '/Department/csp_network',
        },
        {
          id: 77,
          display_name: 'Mandate',
          name:"mandate",
          route: '/Department/mandate',
        },
        {
          id: 78,
          display_name: 'CSP Activity',
          name:"csp_activity",
          route: '/Department/csp_activity',
        },
        {
          id: 79,
          display_name: 'Transaction Report',
          name:"transaction_report",
          route: '/Department/transaction_report',
        },
        {
          id: 80,
          display_name: 'Commission Report',
          name:"commission_reports",
          route: '/Department/ratna/transaction_reports',
        },
        {
          id: 81,
          display_name: 'MATM Activation Report',
          name:"MATM Activation Report",
          route: '/Department/MATM_Activation_Report',
        },
        {
          id: 82,
          display_name: 'Passbook printer Activation Report',
          name:"Passbook printer Activation Report",
          route: '/Department/Passbook_printer_Activation_Report',
        },
        {
          id: 83,
          display_name: 'Tab Activation Report',
          name:"Tab Activation Report",
          route: '/Department/Tab_Activation_Report',
        },
        {
          id: 86,
          display_name: 'Non FI Activity',
          name:"Non FI Activity",
          route: '/Department/Non_FI_Activity',
        },
        {
          id: 87,
          display_name: 'Non FI Transaction',
          name:"Non FI Transaction",
          route: '/Department/Non_FI_Transaction',
        },
      ]
    },
    {
      id: 'U',
      name: 'mandate',
      display_name: 'Mandate',
      children: [
        {
          id: 104,
          name: 'mandate',
          display_name: 'Mandate',
          route: '/Admin/mandate',
        },
        {
          id: 105,
          name: 'surrender',
          display_name: 'Surrender',
          route: '/Admin/surrender',
        },
      ]
    },
    {
      id: 'V',
      name: 'wallet',
      display_name: 'Wallet',
      children: [
        {
          id: 108,
          name: 'wallet',
          display_name: 'Wallet',
          route: '/Admin/wallet',
        },
        {
          id: 109,
          name: 'wallet_topup',
          display_name: 'DS Topup Request',
          route: '/Admin/ds_wallet_topup_request',
        },
        {
          id: 110,
          name: 'hardware_request',
          display_name: 'Hardware Request',
          route: '/Admin/hardware_request',
        },
        {
          id: 111,
          name: 'bankdeposit_request',
          display_name: 'Bank Deposit Request',
          route: '/Admin/bankdeposit_request',
        },
        {
          id: 112,
          name: 'ds_payment_link',
          display_name: 'DS Payment Link',
          route: '/Admin/ds_payment_link',
        },
        {
            id: 114,
            name: 'csp_mapping',
            display_name: 'CSP Mapping Request',
            route: "/Admin/csp_mapping_request"
        },
      ]
    },
    {
      id: 'W',
      name: 'hr Department',
      display_name: 'HR Department',
      children: [
        {
          id: 106,
          name: 'Employee Onboarding',
          display_name: 'Employee Onboarding',
          route: '/Admin/employee_onboard',
        },
        {
          id: 113,
          name: 'Add Department',
          display_name: 'Add Department',
          route: '/Admin/surrender',
        },
      ]
    },
    {
      id: 'X',
      name: 'dev',
      display_name: 'Dev',
      children: [
        {
          id: 115,
          name: 'logs',
          display_name: 'Log Monitoring',
          route: '/dev/logs',
        },
        {
          id: 119,
          name: 'delete_user',
          display_name: 'Delete User',
          route: '/dev/delete_user',
        },
        {
          id: 122,
          name: 'email_content',
          display_name: 'Email Content',
          route: '/Admin/email_content',
        },
      ]
    },
  ]

  const location = useLocation()

  // console.log("location", location);

  function findRouteInfo(route) {
    for (const menu of Access) {
      const child = menu.children.find(child => child.route === route);
      if (child) {
        return {
          childId: child.id,
          parentId: menu.id,
        };
      }
    }
    return null;
  }

  function isChildInItems(childId, parentId) {
    return UserAccess.some(item => item.menu_id === parentId && item.item_id.includes(childId));
  }

  // check for path access

  useEffect(() => {
    if (location && UserAccess && location.pathname !== "/dashboard/default") {
      let routeaccess = findRouteInfo(location.pathname)
      // console.log("routeaccess", routeaccess);

      if (routeaccess) {
        const isInItems = isChildInItems(routeaccess.childId, routeaccess.parentId)
        if (!isInItems) {
          setPreventPage(true)
          alert("Access denied!!!")
          sessionStorage.clear()
          localStorage.clear()
          window.location.href = "/";
          setError(true);
          setErrorMessage("Access denied!!")
        }
        else{
          setPreventPage(false)
        }

      }

    }
    else{
      setPreventPage(false)
    }
  }, [UserAccess,location])



  // console.log("Access", UserAccess, location);

  const handleClose = () => {
    setError(false);
  }
  useEffect(() => {
    const disableContextMenu = (event) => event.preventDefault();
    const disableShortcuts = (event) => {
      if (
        event.ctrlKey &&
        ['u', 's', 'c', 'j'].includes(event.key.toLowerCase()) // Ctrl + U, Ctrl + S, Ctrl + Shift + J
      ) {
        event.preventDefault();
      }
    };

    document.addEventListener('contextmenu', disableContextMenu);
    document.addEventListener('keydown', disableShortcuts);

    return () => {
      document.removeEventListener('contextmenu', disableContextMenu);
      document.removeEventListener('keydown', disableShortcuts);
    };
  }, []);
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes(customization)}>
        <CssBaseline />
        <NavigationScroll>
          <Snackbar anchorOrigin={{ horizontal: 'right', vertical: 'top' }} open={Error} autoHideDuration={6000} onClose={handleClose}>
            <Alert
              onClose={handleClose}
              severity="error"
              variant="filled"
              sx={{ width: '100%' }}
            >
              {ErrorMessage}
            </Alert>
          </Snackbar>
          {
            PreventPage?
            <Box sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0, 0, 0,0.9)",
              zIndex: "9999",
              display: "block"
            }} />
            :
            null
          }

          <Routes />

        </NavigationScroll>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
